// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"Spinner_ldsRipple__2_vdF"};